import { render, staticRenderFns } from "./a-video.vue?vue&type=template&id=9bad77d6&scoped=true"
import script from "./a-video.vue?vue&type=script&lang=js"
export * from "./a-video.vue?vue&type=script&lang=js"
import style0 from "./a-video.vue?vue&type=style&index=0&id=9bad77d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bad77d6",
  null
  
)

export default component.exports